export const ButtonType = {
	SOLID: 'Default',
	GHOST: 'Secondary',
	LINK: 'Link',
	SOLID_ICON: 'Default_Icon',
	GHOST_ICON: 'Secondary_Icon',
	UTILITY: 'Utility',
	CHIP: 'Chip'
};

export const ButtonVariant = {
	NEUTRAL: 'neutral',
	DESTRUCTIVE: 'destructive',
	STANDARD: 'standard',
	UTILITY: 'utility',
	CHIP: 'chip'
};

export const ButtonSize = {
	DEFAULT: 'default',
	SMALL: 'small'
};
